<template>
  <div class="register">
      <!-- 选择 -->
      <r-select v-if="page == 'select'"></r-select>
      <!-- 猎企注册 -->
      <r-hc v-if="page == 'hc'"></r-hc>
      <!-- 猎头注册 -->
      <r-hh v-if="page == 'hh'"></r-hh>
  </div>
</template>
<style lang="scss" scoped>
  
</style>
<script>

import rSelect from './components/rSelect';
import rHc from './components/rHc';
import rHh from './components/rHh';

export default {
  name: "register-module",
  data(){
    return {
      type:'',
      page: this.$route.params.type || ''
    }
  },
  watch: {
      '$route'(to,from){
          this.page = to.params.type;
      }
  },
  components: {
      rSelect,rHc , rHh
  },
  methods: {
     
  },
  created() {
      
  }
};
</script>
